var map = {
	"./3_dots.svg": "5c5a",
	"./3_dots_dark.svg": "fe23",
	"./404/fb.svg": "4527",
	"./404/ig.svg": "0fac",
	"./404/lin.svg": "0f99",
	"./404/tg.svg": "f2a6",
	"./active-substep.svg": "845e",
	"./active_step.svg": "4fea",
	"./arrows/down-grey-long-arrow.svg": "64cd",
	"./arrows/down_grey_arrow.svg": "6a01",
	"./arrows/down_orange_3_arrow.svg": "eea4",
	"./arrows/down_orange_arrow.svg": "1aac",
	"./arrows/left_grey_arrow.svg": "a846",
	"./arrows/left_orange_arrow.svg": "e2ea",
	"./arrows/left_white_arrow.svg": "c46f",
	"./arrows/right-grey-lighter-arrow.svg": "5c91",
	"./arrows/right_arrow_yellow_border.svg": "590d",
	"./arrows/right_dark_grey_arrow.svg": "8c10",
	"./arrows/right_grey_arrow.svg": "ca96",
	"./arrows/right_grey_arrow_dark.svg": "14b6",
	"./arrows/right_orange_3_arrow_dark.svg": "78ec",
	"./badge.svg": "76d9",
	"./balloon.svg": "5c64",
	"./banks/abanca.svg": "99d2",
	"./banks/and-more.svg": "48b7",
	"./banks/banif.svg": "8f50",
	"./banks/cgd.svg": "a396",
	"./banks/credito-agricola.svg": "db04",
	"./banks/montepio.svg": "4baf",
	"./banks/n26.svg": "a185",
	"./banks/novobanco.svg": "0dc5",
	"./banks/revolut.svg": "3048",
	"./banks/santander.svg": "ec77",
	"./birds.svg": "267b",
	"./blake.svg": "5cf5",
	"./bug.svg": "c9c5",
	"./bullet-orange.svg": "ee9a",
	"./bullet.svg": "9408",
	"./card-orange.svg": "ccd5",
	"./card.svg": "af81",
	"./cards/american_express.svg": "e323",
	"./cards/mastercard.svg": "3618",
	"./cards/sepa.svg": "df69",
	"./cards/visa.svg": "85e8",
	"./check-2.svg": "aa48",
	"./check.svg": "4a24",
	"./check_circle.svg": "364c",
	"./check_grey_border.svg": "5b47",
	"./check_white.svg": "9e61",
	"./checkbox_off.svg": "8e5a",
	"./checkbox_on.svg": "0158",
	"./chev-left.svg": "70db",
	"./chev-right-2.svg": "3099",
	"./chev-right-4.svg": "46dc",
	"./chev-right-white.svg": "9b09",
	"./chev-right-yellow.svg": "ff85",
	"./chev-right.svg": "feda",
	"./clock.svg": "3175",
	"./clock_yellow.svg": "ac9f",
	"./contracts/clock-orange.svg": "8071",
	"./contracts/clock-white.svg": "f47e",
	"./contracts/mkt-white.svg": "842c",
	"./contracts/money-white.svg": "d9df",
	"./contracts/tick-green.svg": "62c1",
	"./contracts/tick-white.svg": "46b4",
	"./copy.svg": "b420",
	"./copy_inverted.svg": "4e8b",
	"./cross-black.svg": "8c02",
	"./cross-white.svg": "7a6d",
	"./cross.svg": "3a4d",
	"./cross_orange.svg": "feb7",
	"./cycle.svg": "1da4",
	"./dashboard/arrow-tip-down.svg": "f41a",
	"./dashboard/arrow-tip-up.svg": "acc9",
	"./dashboard/charges.svg": "2fa5",
	"./dashboard/transfer_funds.svg": "4df1",
	"./dashboard/waiting_time.svg": "23df",
	"./done_step.svg": "7bbd",
	"./email.svg": "da8d",
	"./email_grey_border.svg": "5f85",
	"./error-page-icon.svg": "55c2",
	"./error.svg": "ec4e",
	"./exclamation_grey_border.svg": "5b18",
	"./expand.svg": "a841",
	"./form/light_bulb_white_border.svg": "bfb1",
	"./garbage-orange.svg": "4eea",
	"./garbage.svg": "77d3",
	"./giftcard-illustration.svg": "c1ff",
	"./goals/10_reduced_inequalities.svg": "a7cb",
	"./goals/10_reduced_inequalities_color.svg": "6b5a",
	"./goals/11_sustainable_cities_and_communities.svg": "611c",
	"./goals/11_sustainable_cities_and_communities_color.svg": "5b75",
	"./goals/12_responsible_consumption_and_production.svg": "7dbb",
	"./goals/12_responsible_consumption_and_production_color.svg": "9217",
	"./goals/13_climate_action.svg": "c30c",
	"./goals/13_climate_action_color.svg": "9d4f",
	"./goals/14_life_below_water.svg": "6f39",
	"./goals/14_life_below_water_color.svg": "678f",
	"./goals/15_life_on_land.svg": "f3bb",
	"./goals/15_life_on_land_color.svg": "c6e3",
	"./goals/16_peace_and_justice_strong_institutions.svg": "3a66",
	"./goals/16_peace_and_justice_strong_institutions_color.svg": "adf0",
	"./goals/17_partnerships_to_achieve_the_goal.svg": "31ce",
	"./goals/17_partnerships_to_achieve_the_goal_color.svg": "56b1",
	"./goals/1_no_poverty.svg": "5f93",
	"./goals/1_no_poverty_color.svg": "2ec2",
	"./goals/2_zero_hunger.svg": "4cef",
	"./goals/2_zero_hunger_color.svg": "caf4",
	"./goals/3_good_health_and_well-being.svg": "0f08",
	"./goals/3_good_health_and_well-being_color.svg": "c136",
	"./goals/4_quality_education.svg": "b4bb",
	"./goals/4_quality_education_color.svg": "4209",
	"./goals/5_gender_equality.svg": "5cd7",
	"./goals/5_gender_equality_color.svg": "b2b9",
	"./goals/6_clean_water_and_sanitation.svg": "d35a",
	"./goals/6_clean_water_and_sanitation_color.svg": "b2b1",
	"./goals/7_affordable_and_clean_energy.svg": "ea5a",
	"./goals/7_affordable_and_clean_energy_color.svg": "8ccc",
	"./goals/8_decent_work_and_economic_growth.svg": "a4d4",
	"./goals/8_decent_work_and_economic_growth_color.svg": "ce40",
	"./goals/9_industry_innovation_and_infrastructure.svg": "38af",
	"./goals/9_industry_innovation_and_infrastructure_color.svg": "1eff",
	"./green-ball.svg": "405a",
	"./green_ball.svg": "b97b",
	"./grey_cross.svg": "25b3",
	"./heart.svg": "6768",
	"./home/autoinvestment.svg": "85a4",
	"./home/strategy.svg": "da7f",
	"./home/wallet.svg": "eec9",
	"./home/wallet_desktop.svg": "2d62",
	"./home/withdraw.svg": "f451",
	"./home/withdraw_disable.svg": "0737",
	"./id_grey_border.svg": "7ff0",
	"./impact/brocoli.svg": "eea0",
	"./impact/clean_energy.svg": "9571",
	"./impact/gamification/bird.svg": "2d16",
	"./impact/gamification/bush-light.svg": "c817",
	"./impact/gamification/bush.svg": "44de",
	"./impact/gamification/bush_blue.svg": "b693",
	"./impact/gamification/cloud.svg": "3c0e",
	"./impact/gamification/components/ball-dark.svg": "d907",
	"./impact/gamification/components/ball-light.svg": "b2f8",
	"./impact/gamification/components/ball-regular.svg": "3430",
	"./impact/gamification/components/ball.svg": "b530",
	"./impact/gamification/components/berry.svg": "b703",
	"./impact/gamification/components/blue-leaf.svg": "553b",
	"./impact/gamification/components/branch.svg": "f02c",
	"./impact/gamification/components/branched-log.svg": "b7f7",
	"./impact/gamification/components/brown-leaf.svg": "35f8",
	"./impact/gamification/components/brown-treetop.svg": "992c",
	"./impact/gamification/components/fat-stalk.svg": "b668",
	"./impact/gamification/components/four-leaves.svg": "ac24",
	"./impact/gamification/components/green-leaf-branch.svg": "1150",
	"./impact/gamification/components/green-treetop.svg": "6150",
	"./impact/gamification/components/leaf-branch.svg": "f2df",
	"./impact/gamification/components/leaf-light.svg": "01f8",
	"./impact/gamification/components/leaf.svg": "924c",
	"./impact/gamification/components/log.svg": "bf93",
	"./impact/gamification/components/main-log.svg": "47d3",
	"./impact/gamification/components/root.svg": "105b",
	"./impact/gamification/components/seed.svg": "c43b",
	"./impact/gamification/components/stalk-medium.svg": "9ae3",
	"./impact/gamification/components/stalk-top.svg": "1d4d",
	"./impact/gamification/components/stalk.svg": "e903",
	"./impact/gamification/components/sub-branch.svg": "8a4d",
	"./impact/gamification/components/subroot-left.svg": "2a4a",
	"./impact/gamification/components/subroot.svg": "3fa4",
	"./impact/gamification/components/treetop.svg": "e7d2",
	"./impact/gamification/soil.svg": "be58",
	"./impact/jobs.svg": "8521",
	"./impact/people.svg": "38fc",
	"./impact/sustainable_land.svg": "5724",
	"./info.svg": "69d9",
	"./linkedin.svg": "b2c5",
	"./loading.svg": "e96b",
	"./location.svg": "4093",
	"./message.svg": "5f5b",
	"./mkt/alert-orange.svg": "9112a",
	"./mkt/bg.svg": "6a8d",
	"./mkt/sell-orange.svg": "ef8e",
	"./navigation/account-details.svg": "dd73",
	"./navigation/giftcards.svg": "4f12",
	"./navigation/help.svg": "9510",
	"./navigation/impact.svg": "2245",
	"./navigation/invite.svg": "305f",
	"./navigation/logout.svg": "639d",
	"./navigation/mobile/dashboard-selected.svg": "f22e",
	"./navigation/mobile/dashboard.svg": "9365",
	"./navigation/mobile/impact-selected.svg": "291c",
	"./navigation/mobile/impact.svg": "43fa",
	"./navigation/mobile/projects-selected.svg": "58a3",
	"./navigation/mobile/projects.svg": "243d",
	"./navigation/mobile/settings.svg": "32ec",
	"./navigation/redeem-code.svg": "60d8",
	"./navigation/settings.svg": "a972",
	"./no_activity.svg": "48ef",
	"./orange-ball-1.svg": "941d",
	"./orange-ball-2.svg": "4743",
	"./orange-chev.svg": "d6a4",
	"./orange_share.svg": "49fa",
	"./padlock.svg": "8d54",
	"./plus.svg": "4eb1",
	"./profile.svg": "1466",
	"./profile_grey.svg": "66dc",
	"./project_categories/blue_economy.svg": "fedc",
	"./project_categories/blue_economy_color.svg": "87c0",
	"./project_categories/blue_economy_details.svg": "1a90",
	"./project_categories/business_in_transition.svg": "65bd",
	"./project_categories/business_in_transition_color.svg": "67ed",
	"./project_categories/business_in_transition_details.svg": "cd2f",
	"./project_categories/green_use_of_land.svg": "400c",
	"./project_categories/green_use_of_land_color.svg": "5360",
	"./project_categories/green_use_of_land_details.svg": "066b",
	"./project_categories/social_economy.svg": "ac82",
	"./project_categories/social_economy_color.svg": "ace7",
	"./project_categories/social_economy_details.svg": "00cd",
	"./project_categories/sustainable_energy.svg": "803e",
	"./project_categories/sustainable_energy_color.svg": "f789",
	"./project_categories/sustainable_energy_details.svg": "b1b5",
	"./radio_off.svg": "027a",
	"./radio_off_dark.svg": "ae54",
	"./radio_on.svg": "0b3f",
	"./security.svg": "fde2",
	"./settings/2fa.svg": "4123",
	"./settings/2fa_border.svg": "c68f",
	"./settings/bank_account_border.svg": "0a4f",
	"./settings/bank_accounts.svg": "fc6d",
	"./settings/bank_accounts_border.svg": "c1bf",
	"./settings/change_password.svg": "bfbb",
	"./settings/change_password_border.svg": "deb5",
	"./settings/change_pin.svg": "9c8a",
	"./settings/change_pin_border.svg": "39ef",
	"./settings/documents.svg": "2a6d",
	"./settings/documents_border.svg": "8758",
	"./settings/email_notifications.svg": "39f6",
	"./settings/email_notifications_border.svg": "56a8",
	"./settings/face_id.svg": "28ac",
	"./settings/face_id_border.svg": "ffbd",
	"./settings/faqs.svg": "b9b8",
	"./settings/faqs_border.svg": "d7b5",
	"./settings/fiscal_information.svg": "c131",
	"./settings/fiscal_information_border.svg": "03f4",
	"./settings/language.svg": "5711",
	"./settings/language_border.svg": "2760",
	"./settings/legal_representative.svg": "b1c8",
	"./settings/legal_representative_border.svg": "7526",
	"./settings/logout.svg": "9115",
	"./settings/logout_border.svg": "fa9b",
	"./settings/organizations_details.svg": "43f9",
	"./settings/organizations_details_border.svg": "8ac3",
	"./settings/personal_details.svg": "dc47",
	"./settings/personal_details_border.svg": "4557",
	"./settings/privacy_policy.svg": "7680",
	"./settings/privacy_policy_border.svg": "a44f",
	"./settings/suitability.svg": "6a3c",
	"./settings/suitability_border.svg": "1987",
	"./settings/terms_and_conditions.svg": "5022",
	"./settings/terms_and_conditions_border.svg": "8e7a",
	"./settings/wallets.svg": "0766",
	"./settings/wallets_border.svg": "b3a9",
	"./share.svg": "940a",
	"./shield.svg": "a001",
	"./small_arrow.svg": "e245",
	"./small_coin.svg": "b185",
	"./small_waiting.svg": "6c4f",
	"./social/e.svg": "13de",
	"./social/f.svg": "b0d4",
	"./social/i.svg": "255a",
	"./social/t.svg": "03b9",
	"./star.svg": "ec6f",
	"./strategies/categories.svg": "394b",
	"./strategies/categories_green.svg": "0517",
	"./strategies/categories_grey_border.svg": "e612",
	"./strategies/dd.svg": "7438",
	"./strategies/dd_green.svg": "f752",
	"./strategies/dd_grey_border.svg": "c669",
	"./strategies/dd_orange.svg": "7a4a",
	"./strategies/edit_pencil.svg": "f476",
	"./strategies/investment.svg": "b98a",
	"./strategies/investment_green.svg": "b67b",
	"./strategies/investment_grey_border.svg": "abe3",
	"./strategies/owner.svg": "7028",
	"./strategies/owner_green.svg": "849c",
	"./strategies/owner_grey_border.svg": "e563",
	"./strategies/plan_name.svg": "6655",
	"./strategies/plan_name_green.svg": "d0fa",
	"./strategies/plan_name_grey_border.svg": "4fa6",
	"./strategies/project_max.svg": "bfb3",
	"./strategies/project_max_green.svg": "5325",
	"./strategies/project_max_grey_border.svg": "5478",
	"./strategies/roundup_grey.svg": "cd8f",
	"./strategies/roundup_grey_desktop.svg": "6a57",
	"./strategies/roundup_orange.svg": "0160",
	"./strategies/strategies.svg": "1ef3",
	"./strategies/topup_grey.svg": "98f4",
	"./strategies/topup_grey_desktop.svg": "a8ea",
	"./strategies/topup_orange.svg": "5b94",
	"./success.svg": "b235",
	"./success_arrow.svg": "5ffb",
	"./timer.svg": "fd1c",
	"./toast/error.svg": "53a9",
	"./toast/success.svg": "cc33",
	"./toast/warning.svg": "4a97",
	"./topup_grey_border.svg": "7fe9",
	"./topup_orange.svg": "4391",
	"./transactions/active_filters.svg": "85db",
	"./transactions/comission.svg": "d262",
	"./transactions/comission_desktop.svg": "0833",
	"./transactions/comission_details.svg": "472b",
	"./transactions/download.svg": "d9b3",
	"./transactions/empty.svg": "0bfb",
	"./transactions/empty_desktop.svg": "0e49",
	"./transactions/filters.svg": "6aab",
	"./transactions/filters_desktop.svg": "cb11",
	"./transactions/giftcard.svg": "7b79",
	"./transactions/giftcard_desktop.svg": "10c0",
	"./transactions/giftcard_desktop_failed.svg": "1cce",
	"./transactions/giftcard_details.svg": "8d2b",
	"./transactions/giftcard_details_failed.svg": "0497",
	"./transactions/giftcard_failed.svg": "601e",
	"./transactions/investment.svg": "d03b",
	"./transactions/investment_desktop.svg": "50d3",
	"./transactions/investment_desktop_failed.svg": "e4dc",
	"./transactions/investment_details.svg": "52da",
	"./transactions/investment_details_failed.svg": "d9c7",
	"./transactions/investment_failed.svg": "4761",
	"./transactions/mkt_desktop_failed.svg": "aab0",
	"./transactions/mkt_details_failed.svg": "a08a",
	"./transactions/mkt_failed.svg": "dcde",
	"./transactions/mkt_purchase.svg": "07bd",
	"./transactions/mkt_purchase_desktop.svg": "5c8e",
	"./transactions/mkt_purchase_details.svg": "2cb5",
	"./transactions/mkt_sale.svg": "0086",
	"./transactions/mkt_sale_desktop.svg": "6d45",
	"./transactions/mkt_sale_details.svg": "9890",
	"./transactions/payment.svg": "5da3",
	"./transactions/payment_desktop.svg": "ce80",
	"./transactions/payment_desktop_failed.svg": "742c",
	"./transactions/payment_details.svg": "03cc",
	"./transactions/payment_details_failed.svg": "c804",
	"./transactions/payment_failed.svg": "f982",
	"./transactions/refund.svg": "c4cf",
	"./transactions/refund_desktop.svg": "409b",
	"./transactions/refund_details.svg": "fc62",
	"./transactions/topup.svg": "62e4c",
	"./transactions/topup_desktop.svg": "f5ff",
	"./transactions/topup_desktop_failed.svg": "33c0",
	"./transactions/topup_details.svg": "a528",
	"./transactions/topup_details_failed.svg": "6bcd",
	"./transactions/topup_failed.svg": "1a3a",
	"./transactions/voucher.svg": "edfb",
	"./transactions/voucher_desktop.svg": "4f17",
	"./transactions/voucher_desktop_failed.svg": "690e",
	"./transactions/voucher_details.svg": "232c",
	"./transactions/voucher_details_failed.svg": "c7d6",
	"./transactions/voucher_failed.svg": "e8d8",
	"./transactions/withdraw.svg": "ec8b",
	"./transactions/withdraw_desktop.svg": "15cd",
	"./transactions/withdraw_details.svg": "89a4",
	"./trash_orange.svg": "9ba1",
	"./vouchers/giftcard_active.svg": "dd62",
	"./vouchers/giftcard_expired.svg": "3abc",
	"./vouchers/giftcard_used.svg": "7e26",
	"./vouchers/referral_active.svg": "d72d",
	"./vouchers/referral_expired.svg": "d394",
	"./vouchers/referral_used.svg": "8195",
	"./vouchers/voucher_active.svg": "a9fd",
	"./vouchers/voucher_expired.svg": "4f79",
	"./vouchers/voucher_used.svg": "5c6f",
	"./waiting-orange.svg": "144c",
	"./waiting.svg": "b1db",
	"./wallet-w-bg.svg": "ed32",
	"./wallet.svg": "d45e",
	"./warning.svg": "45a1",
	"./white-ball.svg": "5e4d",
	"./yellow-ball-2.svg": "8da1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";